export const BOOK_DATA_URL = 'https://raw.githubusercontent.com/ColinEberhardt/d3fc-webgl-hathi-explorer/master/data.tsv';
export function parseBookDatum(d) {
    return Object.assign(Object.assign({}, d), { x: Number(d.x), y: Number(d.y), date: Number(d.date) });
}
export function annotateBookDatum(d) {
    var _a, _b;
    let title = (_a = d.title) !== null && _a !== void 0 ? _a : '';
    if (title.length > 50)
        title = title.substr(0, 50) + '...';
    let label = `${(_b = d.first_author_name) !== null && _b !== void 0 ? _b : 'Unknown'} \n${d.date}`;
    if (d.language)
        label += ` \n(${d.language})`;
    const note = { title, label, wrapSplitter: /\n/, bgPadding: 3 };
    return { note, x: d.x, y: d.y, dx: 20, dy: 20 };
}
